import { cn } from "../util";

/**
 * "Vera." según el kit: Bitter Black 900, letras en tinta y el punto terminal
 * DIBUJADO en naranja (no el glifo del punto). Proporciones medidas del logo:
 * diámetro ≈ 0.23 × altura de mayúscula, hueco previo ≈ 0.13 × altura de
 * mayúscula, alineado a la línea base. Con cap height ≈ 0.7em: .17em y .085em.
 */
export function Wordmark({
  className,
  tamano = "text-3xl",
  texto = "Vera",
}: {
  className?: string;
  /** Clase de tamaño de Tailwind; el punto escala con el em. */
  tamano?: string;
  /** Solo "Vera" o "V" (app mark). Nunca en mayúsculas. */
  texto?: "Vera" | "V";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-baseline font-titulo font-black leading-none tracking-normal text-tinta",
        tamano,
        className,
      )}
      aria-label={`${texto}.`}
    >
      <span>{texto}</span>
      <PuntoNaranja />
    </span>
  );
}

/** El punto terminal naranja, reutilizable al final de un título. */
export function PuntoNaranja({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-block rounded-full bg-naranja", className)}
      style={{ width: ".17em", height: ".17em", marginLeft: ".085em" }}
    />
  );
}

/** App mark "V." para avatares e iconos pequeños. */
export function AppMark({ className }: { className?: string }) {
  return <Wordmark texto="V" tamano="text-2xl" className={className} />;
}
